import { createContext, useContext } from 'react';
import type { WalletClient } from 'viem';
import type { Chain } from 'viem/chains';

export interface WalletInfo {
  address: string;
}

export interface WalletInterface {
  chain: Chain;
  ready: boolean;
  authSettled: boolean;
  isConnected: boolean;
  rawIsConnected: boolean;
  walletClientLoading: boolean;
  walletClientError?: Error | null;
  connectModalOpen: boolean;
  retryWalletClient?: () => Promise<unknown>;
  isConnecting: boolean;
  wallet?: WalletInfo;
  walletClient?: WalletClient;
  disconnect: () => void | Promise<void>;
  openConnectModal?: () => void;
  connectInjected?: () => Promise<unknown>; // Skip wallet picker in in-app browsers
  wrongNetwork?: boolean; // wagmi connected, but the wallet sits on a chain other than APP_CHAIN
  switchToAppChain?: () => Promise<unknown>;
}

export const WalletContext = createContext<WalletInterface>({
  ready: false,
  authSettled: false,
  isConnected: false,
  isConnecting: false,
  disconnect: () => {},
} as WalletInterface);

export const useWallet = () => {
  return useContext(WalletContext);
};
